import { v4 as uuidv4 } from 'uuid';

export const mockConcertData = {
  coldplay: {
    venueProfile: {
      venueName: "Wembley Stadium",
      venueType: "arena",
      capacity: "90000",
      openingYear: "2007",
      indoorOutdoor: "hybrid",
      venueAddress: "London, UK",
      venueDescription: "Iconic stadium venue with retractable roof and state-of-the-art sound system"
    },
    equipmentItems: [
      {
        id: uuidv4(),
        equipmentName: "L-Acoustics K1 Line Array",
        manufacturer: "L-Acoustics",
        model: "K1",
        systemCategory: "audio",
        installDate: "2023-01-15",
        lastMaintenanceDate: "2025-03-12",
        condition: "excellent",
        criticalityLevel: "mission-critical",
        maintenanceFrequency: "monthly"
      },
      {
        id: uuidv4(),
        equipmentName: "DiGiCo SD7 Console",
        manufacturer: "DiGiCo",
        model: "SD7",
        systemCategory: "audio",
        installDate: "2022-08-20",
        lastMaintenanceDate: "2025-04-05",
        condition: "good",
        criticalityLevel: "mission-critical",
        maintenanceFrequency: "quarterly"
      },
      {
        id: uuidv4(),
        equipmentName: "Claypaky Scenius Unico",
        manufacturer: "Claypaky",
        model: "Scenius Unico",
        systemCategory: "lighting",
        installDate: "2024-02-10",
        lastMaintenanceDate: "2025-04-01",
        condition: "excellent",
        criticalityLevel: "high",
        maintenanceFrequency: "monthly"
      },
      {
        id: uuidv4(),
        equipmentName: "LED Video Wall P3.9",
        manufacturer: "Absen",
        model: "PL 3.9 Pro",
        systemCategory: "video",
        installDate: "2023-07-25",
        lastMaintenanceDate: "2025-02-20",
        condition: "good",
        criticalityLevel: "high",
        maintenanceFrequency: "quarterly"
      }
    ],
    maintenanceHistory: [
      {
        id: uuidv4(),
        systemCategory: "audio",
        componentName: "L-Acoustics K1 Array",
        issueType: "degradation",
        dateDiscovered: "2025-01-10",
        resolution: "Recalibrated and replaced damaged drivers",
        repairCost: "2500",
        downtime: "12",
        technician: "Alex Johnson",
        rootCause: "Excessive usage during festival season"
      },
      {
        id: uuidv4(),
        systemCategory: "lighting",
        componentName: "Claypaky Scenius Unico",
        issueType: "failure",
        dateDiscovered: "2025-02-05",
        resolution: "Replaced motor and control board",
        repairCost: "1800",
        downtime: "24",
        technician: "Sarah Rodriguez",
        rootCause: "Power surge during thunderstorm"
      },
      {
        id: uuidv4(),
        systemCategory: "video",
        componentName: "LED Video Wall Controller",
        issueType: "malfunction",
        dateDiscovered: "2025-03-15",
        resolution: "Software update and component replacement",
        repairCost: "950",
        downtime: "6",
        technician: "Michael Chen",
        rootCause: "Outdated firmware causing compatibility issues"
      }
    ],
    upcomingEvents: [
      {
        id: uuidv4(),
        eventName: "Coldplay: Music of the Spheres World Tour",
        eventType: "concert",
        eventDate: "2025-06-15",
        eventDuration: "4",
        expectedAttendance: "85000",
        setupTime: "72",
        breakdownTime: "48",
        criticalSystems: ["Main PA", "LED Screens", "Stage Lighting"],
        specialRequirements: "Interactive LED wristbands for all attendees, CO2 neutral power supply"
      },
      {
        id: uuidv4(),
        eventName: "FA Cup Final",
        eventType: "sporting",
        eventDate: "2025-05-20",
        eventDuration: "3",
        expectedAttendance: "89000",
        setupTime: "48",
        breakdownTime: "24",
        criticalSystems: ["Broadcast Systems", "Scoreboard", "Field Lighting"],
        specialRequirements: "VAR technology setup, multiple broadcast feeds"
      }
    ],
    systemInteractions: [
      {
        id: uuidv4(),
        primarySystem: "Main Power Distribution",
        dependentSystems: ["Audio", "Lighting", "HVAC", "Video"],
        failureImpact: "critical",
        backupSystem: "Diesel generators with UPS",
        integrationComplexity: "high",
        notes: "Main generator requires service before June events"
      },
      {
        id: uuidv4(),
        primarySystem: "Audio DSP Network",
        dependentSystems: ["Main PA", "Monitoring", "Broadcast Feed"],
        failureImpact: "high",
        backupSystem: "Redundant processor and analog backup",
        integrationComplexity: "medium",
        notes: "Network switch replacement scheduled for next month"
      }
    ],
    pastIssues: [
      {
        id: uuidv4(),
        eventTypeAffected: "concert",
        systemAffected: "Audio",
        issueDate: "2024-11-10",
        impactSeverity: "high",
        problemDescription: "Main left array experienced partial failure during headliner performance",
        resolution: "Emergency swap to backup amplifiers",
        attendanceImpact: "minimal",
        revenueImpact: "none",
        preventionSteps: "Implemented pre-show stress testing protocol"
      },
      {
        id: uuidv4(),
        eventTypeAffected: "sporting",
        systemAffected: "Video",
        issueDate: "2024-12-05",
        impactSeverity: "medium",
        problemDescription: "South end display showed artifacts during second half",
        resolution: "Reset video processors during halftime",
        attendanceImpact: "none",
        revenueImpact: "none",
        preventionSteps: "Added redundant signal path and automatic failover"
      }
    ]
  },
  duaLipa: {
    venueProfile: {
      venueName: "Madison Square Garden",
      venueType: "arena",
      capacity: "20000",
      openingYear: "1968",
      indoorOutdoor: "indoor",
      venueAddress: "New York, NY",
      venueDescription: "Historic indoor arena with premium acoustics and multi-level seating"
    },
    equipmentItems: [
      {
        id: uuidv4(),
        equipmentName: "d&b audiotechnik J-Series",
        manufacturer: "d&b audiotechnik",
        model: "J-Series",
        systemCategory: "audio",
        installDate: "2024-01-10",
        lastMaintenanceDate: "2025-03-20",
        condition: "excellent",
        criticalityLevel: "mission-critical",
        maintenanceFrequency: "monthly"
      },
      {
        id: uuidv4(),
        equipmentName: "Avid S6L Console",
        manufacturer: "Avid",
        model: "S6L",
        systemCategory: "audio",
        installDate: "2023-11-15",
        lastMaintenanceDate: "2025-04-02",
        condition: "good",
        criticalityLevel: "mission-critical",
        maintenanceFrequency: "quarterly"
      },
      {
        id: uuidv4(),
        equipmentName: "Martin MAC Viper",
        manufacturer: "Martin",
        model: "MAC Viper",
        systemCategory: "lighting",
        installDate: "2024-03-05",
        lastMaintenanceDate: "2025-04-10",
        condition: "good",
        criticalityLevel: "high",
        maintenanceFrequency: "monthly"
      }
    ],
    maintenanceHistory: [
      {
        id: uuidv4(),
        systemCategory: "audio",
        componentName: "d&b J-Series Array",
        issueType: "preventive",
        dateDiscovered: "2025-02-15",
        resolution: "Full system calibration and driver inspection",
        repairCost: "1200",
        downtime: "8",
        technician: "James Wilson",
        rootCause: "Scheduled maintenance"
      },
      {
        id: uuidv4(),
        systemCategory: "lighting",
        componentName: "Martin MAC Viper",
        issueType: "degradation",
        dateDiscovered: "2025-03-01",
        resolution: "Replaced bulbs and cleaned optics",
        repairCost: "750",
        downtime: "4",
        technician: "Lisa Park",
        rootCause: "Normal wear and tear"
      }
    ],
    upcomingEvents: [
      {
        id: uuidv4(),
        eventName: "Dua Lipa: Future Nostalgia Tour",
        eventType: "concert",
        eventDate: "2025-05-28",
        eventDuration: "3",
        expectedAttendance: "19500",
        setupTime: "36",
        breakdownTime: "24",
        criticalSystems: ["Main PA", "Floor Lighting", "Stage Effects"],
        specialRequirements: "High-power laser system, CO2 jets, extended stage runway"
      },
      {
        id: uuidv4(),
        eventName: "New York Knicks vs. Brooklyn Nets",
        eventType: "sporting",
        eventDate: "2025-06-05",
        eventDuration: "3",
        expectedAttendance: "19000",
        setupTime: "12",
        breakdownTime: "6",
        criticalSystems: ["Scoreboard", "Court Lighting", "Broadcast Systems"],
        specialRequirements: "Court conversion from concert setup, NBA broadcast requirements"
      }
    ],
    systemInteractions: [
      {
        id: uuidv4(),
        primarySystem: "Central Show Control",
        dependentSystems: ["Audio", "Lighting", "Video", "Special Effects"],
        failureImpact: "critical",
        backupSystem: "Redundant control system with manual override",
        integrationComplexity: "high",
        notes: "Software update required before Dua Lipa concert"
      }
    ],
    pastIssues: [
      {
        id: uuidv4(),
        eventTypeAffected: "concert",
        systemAffected: "Special Effects",
        issueDate: "2025-01-20",
        impactSeverity: "medium",
        problemDescription: "CO2 jets failed to activate during key moments",
        resolution: "Replaced solenoid valves and control module",
        attendanceImpact: "minor",
        revenueImpact: "none",
        preventionSteps: "Implemented pre-show testing protocol for all effects"
      }
    ]
  }
};

export const getRandomMockData = () => {
  const mockOptions = [mockConcertData.coldplay, mockConcertData.duaLipa];
  return mockOptions[Math.floor(Math.random() * mockOptions.length)];
};